import { PersonAdd } from "@material-ui/icons";
import React from "react";
import {
    Button,
    useRedirect
} from "react-admin";

const AddNewClientButton = ({ redirectTo }) => {

    const redirect = useRedirect()

    return (
        <Button
            style={{ marginTop: '2em' }}
            onClick={() => { redirect('create', '/clients', {}, {}, { redirect: redirectTo }) }}
            label="Inserir cliente"
            variant="contained"
        >
            <PersonAdd />
        </Button >
    );
}

export default AddNewClientButton;